var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_2260","data-name":"Path 2260","d":"M-6571.543-2220.743l9.9,10.065,9.461-10.065","transform":"translate(6646.506 1992.185) rotate(-2)","fill":"none","stroke":"#e5752d","strokeLinecap":"round","strokeWidth":"2"}));
}

ChevronDown.defaultProps = {"width":"22.629","height":"13.689","viewBox":"0 0 22.629 13.689"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
